import type { ProAdminDataDeletionListDto, ProAdminDataDeletionQuery } from "@dutyon/apis";

const invalid = () => new Error("삭제 요청 목록을 확인할 수 없습니다.");
const id = (value: unknown) => typeof value === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(value);
const date = (value: unknown) =>
  typeof value === "string" &&
  Number.isFinite(Date.parse(value)) &&
  new Date(value).toISOString() === value;
export function prepareDeletionFilters(from: string, to: string): ProAdminDataDeletionQuery {
  for (const value of [from, to])
    if (
      value &&
      (!/^20\d\d-\d{2}-\d{2}$/.test(value) ||
        !Number.isFinite(Date.parse(value)) ||
        new Date(value).toISOString().slice(0, 10) !== value)
    )
      throw invalid();
  if (from && to && from > to) throw invalid();
  return { ...(from ? { from } : {}), ...(to ? { to } : {}) };
}
export function readDeletionList(value: unknown, cursor?: string): ProAdminDataDeletionListDto {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw invalid();
  const data = value as ProAdminDataDeletionListDto;
  if (
    Object.keys(data).some((key) => !["items", "nextCursor"].includes(key)) ||
    !Array.isArray(data.items) ||
    data.items.length > 20 ||
    !(data.nextCursor === null || id(data.nextCursor)) ||
    data.nextCursor === cursor
  )
    throw invalid();
  const seen = new Set<string>();
  for (const row of data.items) {
    if (
      !row ||
      typeof row !== "object" ||
      Array.isArray(row) ||
      Object.keys(row).some(
        (key) => !["workspaceId", "revision", "status", "requestedAt", "closedAt"].includes(key),
      ) ||
      !id(row.workspaceId) ||
      seen.has(row.workspaceId) ||
      row.workspaceId === cursor ||
      !Number.isInteger(row.revision) ||
      row.revision < 1 ||
      row.revision > 2147483647 ||
      row.status !== "REQUESTED" ||
      !date(row.requestedAt) ||
      !date(row.closedAt) ||
      Date.parse(row.closedAt) > Date.parse(row.requestedAt)
    )
      throw invalid();
    seen.add(row.workspaceId);
  }
  if (
    data.nextCursor !== null &&
    (data.items.length !== 20 || data.nextCursor !== data.items[data.items.length - 1].workspaceId)
  )
    throw invalid();
  return data;
}
export function deletionDate(value: string) {
  return new Intl.DateTimeFormat("ko-KR", {
    timeZone: "Asia/Seoul",
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}
